export default function parseJson(response) {
  return response.json()
    .then((json) => {
      if (!response.ok) {
        throw Error("parseJson" + json.e.message);
      } else {
        return json;
      }
    });
}



// WEBPACK FOOTER //
// ./src/utils/json.js